import { Col, Form, Row } from "react-bootstrap"

export const TextForm = props => {
    //reqiured
    const { value, onChange } = props;
    //optional
    const { title, placeholder, hidden, disabled, type, cn, auto, noMargin } = props;
    
    return (
        <Form.Group className={noMargin ? '' : cn || 'mb-3'} hidden={hidden || false}>
            <Form.Label hidden={noMargin}>{title || ''}</Form.Label>
            <Form.Control type={type || 'text'} placeholder={placeholder || ''} value={value} onChange={onChange} disabled={disabled || false} autoComplete={auto || ""} />
        </Form.Group>
    )
}

export const TextEditForm = props => {
    //reqiured
    const { value, onEdit, children } = props;
    //optional
    const { title, subtitle } = props;
    return (
        <div style={{marginTop : '-12px'}}>
            <Form.Group>
                <Row bsPrefix="row align-items-center">
                    <Col bsPrefix="col-sm-6 d-none d-sm-block">
                        <div className="bold">{title || ''}</div>
                        <div className="bold">{subtitle || ''}</div>
                    </Col>
                    <Col bsPrefix="col-xs-12 d-block d-sm-none">
                        <div className="bold">{`${title} / ${subtitle}`}</div>
                    </Col>
                    <Col>
                        {onEdit ? children : <div>{value}</div>}
                    </Col>
                </Row>
            </Form.Group>
            <hr style={{marginTop : '5px'}}/>
        </div>
    )
}



export const SelectForm = props => {
    //reqiured
    const { value, onChange, options } = props;
    //optional
    const { title, noMargin, disabled, fontSize } = props;

    const mappingOptions = () => {
        if (Array.isArray(options)) {
            return options.map((o, i) => (<option key={i} value={o}>{o}</option>))
        }
        else if (typeof options === 'object') {
            return Object.keys(options).map((k, i) => (<option key={i} value={k}>{options[k]}</option>))
        }
        else {
            return <option>-</option>
        }
    }

    return (
        <Form.Group className={!noMargin ? 'mb-3' : ''}>
            <Form.Label hidden={noMargin || false}>{title}</Form.Label>
            <Form.Select value={value} onChange={onChange} disabled={disabled || false}  style={{fontSize : fontSize || '16px'}}>{mappingOptions()}</Form.Select>
        </Form.Group>
    )
}

export const FileForm = props => {
    //reqiured
    const { onChange } = props;
    //optional
    const { title, hidden, accept, disabled } = props;

    return (
        <Form.Group className="mb-3">
            <Form.Label>{title}</Form.Label>
            <Form.Control type="file" onChange={onChange} accept={accept || ''}  hidden={hidden || false} disabled={disabled || false}/>
        </Form.Group>
    )
}

export const DateForm = props => {
    //reqiured
    const { value, onChange } = props;
    //optional
    const { title, hidden, disabled, noMargin } = props;

    const checkInput = e => {
        e.target.value = e.target.value.replace(/[^0-9-]/g, '')
        
        if (e.target.value) {
            if (e.target.value.length > 10) {
                e.target.value = e.target.value.substring(0, 10)
            }
            switch (e.target.value.length) {
                case 5:
                    if (!isNaN(e.target.value.charAt(5)) && e.target.value.charAt(4) !== '-') {
                        e.target.value = e.target.value.substring(0, 4) + '-' + e.target.value.substring(4, 5)
                    }
                    break;
                case 8:
                    if (!isNaN(e.target.value.charAt(8)) && e.target.value.charAt(7) !== '-') {
                        if (e.target.value.charAt(6) === '-' && !isNaN(e.target.value.charAt(5))) {
                            e.target.value = e.target.value.substring(0, 5) + '0' + e.target.value.charAt(5) + '-' + e.target.value.charAt(7)
                        }
                        else {
                            e.target.value = e.target.value.substring(0, 7) + '-' + e.target.value.substring(7, 8)
                        }
                    }
                    break;
                default:
                    break;
            }
        }
        onChange(e)
    }
    
    return (
        <Form.Group className={noMargin ? '' : 'mb-3'} hidden={hidden || false}>
            <Form.Label hidden={noMargin}>{title || ''}</Form.Label>
            <Form.Control value={value} onChange={checkInput} disabled={disabled || false} placeholder="YYYY-MM-DD เช่น 2000-12-31"/>
        </Form.Group>
    )
}